import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { isOptionActive, Option } from '@dch/products-business-logic';
import { OnDestroyHookDirective } from 'src/app/shared/hooks';
import { OrderingStatusDataModel } from 'src/app/shared/models/ebu-ordering.model';
import { ApplicationState, getEbuOrderingStatus } from 'src/app/store/reducers';

@Component({
  selector: 'mprd-ebu-order-validation-modal',
  templateUrl: './ebu-order-validation-modal.component.html',
})
export class EbuOrderValidationModalComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  public destroy: Function;
  option: Option;
  acceptTermsAndConditions = false;
  confirm: Function;
  cancel: Function;
  orderingInput: any;

  constructor(private store: Store<ApplicationState>) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.store.select(getEbuOrderingStatus).subscribe((value) => {
        if (
          value === OrderingStatusDataModel.ERROR ||
          value === OrderingStatusDataModel.SUCCESS
        ) {
          this.destroy();
        }
      }),
    );
  }

  confirmOrder() {
    if (this.confirm) {
      this.confirm();
    }
    this.destroy();
  }

  close() {
    this.destroy();
  }

  isActiveOption() {
    return this.option && isOptionActive(this.option);
  }

  protected getOptionName() {
    if (this.option) {
      if (this.option.packDescription) {
        return this.option.packDescription;
      } else {
        return this.option.name;
      }
    }
  }

  canDoOrderAction = (option: Option) =>
    this.isActiveOption()
      ? option.isCeasable && !option.suspended
      : option.isOrderable && !option.suspended && option.noCreditToOrder;
}
